import React from 'react';

const LoadingSpinner = ({ logo }) => (
  <div className="flex items-center justify-center h-screen bg-wedding-white">
    <div className="relative w-24 h-24 animate-spin rounded-full border-4 border-wedding-sage border-t-transparent">
      <img src={logo} alt="Wedding Logo" className="absolute inset-0 m-auto w-16 h-16 object-contain" />
    </div>
  </div>
);

export default LoadingSpinner;